<template>
  <div class="col-md-12 filter-btn">
    <div>
  <span @click="$store.commit('openFilter')">
    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12" viewBox="0 0 15.5 12">
  <g id="Raggruppa_121" data-name="Raggruppa 121" transform="translate(-326.5 -278)">
    <g id="Ellisse_2" data-name="Ellisse 2" transform="translate(337 278)" fill="none" stroke="#fff" stroke-width="1">
      <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
      <circle cx="2.5" cy="2.5" r="2" fill="none"/>
    </g>
    <g id="Ellisse_3" data-name="Ellisse 3" transform="translate(331.5 290) rotate(180)" fill="none" stroke="#fff"
       stroke-width="1">
      <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
      <circle cx="2.5" cy="2.5" r="2" fill="none"/>
    </g>
    <line id="Linea_2" data-name="Linea 2" x2="11" transform="translate(326.5 280.5)" fill="none" stroke="#fff"
          stroke-width="1"/>
    <line id="Linea_3" data-name="Linea 3" x2="11" transform="translate(342 287.5) rotate(180)" fill="none"
          stroke="#fff" stroke-width="1"/>
  </g>
</svg>
</span>

      <span @click="$store.commit('openFilter')" class="filter-title">{{ trans.get('public.filter.products') }}</span>
      <span @click="$store.commit('openFilter')">
        <svg id="caret-filter" :class="($store.state.openedFilter)? 'opened': ''" xmlns="http://www.w3.org/2000/svg"
             width="7.492" height="13.57" viewBox="0 0 7.492 13.57">
      <path id="Tracciato_75" data-name="Tracciato 75" d="M434.679,246.374l6.432,6.432,2.144-2.144,4.288-4.288"
            transform="translate(-246.02 447.895) rotate(-90) " fill="none" stroke="#fff" stroke-width="1"/>
    </svg>

      </span>
    </div>
    <div v-if="$store.state.openedFilter" class="filtro">
      <div class="row">
        <div class="col-md-12 cat-title">
          {{ trans.get('public.filter.categories') }}
        </div>
        <div class="col-md-12 cat-icons">
          <ul class="cats">
            <li :title="cat.desc" v-for="cat in listaCategorie" @click="selectCategory(cat.code)">
              <img
                  :src="url('/storage/media/icons/svg/category/white/' + cat.fam.toLowerCase().replace('+', 'plus') + '-' + cat.code.toLowerCase() + '.svg')"
              >
              <span class="cat-desc">{{ cat.desc }}</span>
              <div v-if="currentCatSelection === cat.code" class="active-bar"></div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="listaColori.length > 0" class="row">
        <div class="col-md-12 color-title">
          {{ trans.get('public.filter.colors') }}
        </div>
        <div class="col-md-12 col-icons">
          <ul class="cols">
            <li v-for="col in listaColori" @click="selectColor(col.code)">
              <div :class="'color-palette ' + col.code.toLowerCase()" :title="col.desc.toLowerCase()"></div>
              <div v-if="currentColSelection === col.code" class="active-bar"></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 reset-filter">
          <span @click="resetFilter">{{ trans.get('public.filter.reset') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      open: false,
      catColorList: this.$store.state.catalog.catcolor,
      catColorList2: this.$store.state.tempCatalog.catcolor,
      listaCategorie: [],
      listaColori: [],
      currentCatSelection: this.$store.state.currentCatSelection,
      currentColSelection: this.$store.state.currentColSelection

    }
  },
  mounted() {
    this.getCategorieColori()
    this.setLocalSearch()
  },
  methods: {
    setLocalSearch() {
      sessionStorage.setItem('search', this.catColorList)
    },
    resetFilter(keep = null) {
      //console.log('resetting...')
      this.$store.commit('setCurrentCat', null)
      this.$store.commit('setCurrentCol', null)
      this.$store.commit('setSearcCat', false)
      this.$store.commit('setSearcCol', false)
      let family = window.location.pathname.split("/")

      family = family[family.length - 1]

      axios({
        method: "get",
        url: window.location.origin + "/catalog/api/catcolor",
        params: {
          code: family,
        },
      }).then((res) => {
        //console.log('getCatColor', res.data)

        this.$store.commit("setCatColors", res.data);


      });
    },
    softResetCat(code){
      this.$store.commit("setCatColors", this.catColorList2);
      this.catColorList = this.catColorList2
      this.$store.commit('setSearcCat', false);
      this.$store.commit('setSearcCol', false);
      this.selectCategory(code)
      this.$store.commit('setCurrentCol', null)
    },
    selectCategory: function (code) {

      if (this.$store.state.isSearchCat) { // se ho già cercato per categoria
        if (this.currentCatSelection === code) {
          this.resetFilter();
        } else {

          this.softResetCat(code)


        }

      } else {

        let filtered = this.catColorList.filter(el =>
            el.cod_categoria === code
        )
        this.$store.commit('setSearcCat', true);
        this.$store.commit('setCatColors', filtered)
        this.$store.commit('setCurrentCat', code)

      }

    },
    softResetCol(code){
      this.$store.commit("setCatColors", this.catColorList2);
      this.catColorList = this.catColorList2

      this.$store.commit('setSearcCol', false);
      this.$store.commit('setCurrentCat', null)
      this.selectColor(code)

    },
    selectColor: function (code) {
      if (this.$store.state.isSearchCol) {
        if (this.currentColSelection === code) {
          this.resetFilter()
        } else {

          this.softResetCol(code)
        }

      } else {

        let filtered = this.catColorList.filter(el =>
            el.cod_colore === code
        )
        this.$store.commit('setSearcCol', true);
        this.$store.commit('setCatColors', filtered)
        this.$store.commit('setCurrentCol', code)

      }

    },


    getCategorieColori: function () {
      this.catColorList2.forEach(el => {
        //console.log(this.listaCategorie.find(obj => obj.code === el.category.codice))
        if (el.category) {
          if (!this.listaCategorie.find(obj => obj.code === el.category.codice)) {
            let tmpObj = {
              fam: el.family.codice,
              code: el.category.codice,
              desc: el.category.descrizione
            }
            this.listaCategorie.push(tmpObj)
          }
        }
        if (el.color !== null) {
          if (!this.listaColori.find(obj => obj.code === el.color.codice)) {
            let tmpObj = {
              code: el.color.codice,
              desc: el.color.descrizione,
              ordinamento: el.color.ordinamento,
            }
            this.listaColori.push(tmpObj)
          }
        }
      });

      // ordinamento dei colori
      // Se li si vuole ga ordinati da backend utilizzare un'altra rotta
      this.listaColori = this.listaColori.sort(function (a, b) {
        return a.ordinamento - b.ordinamento;
      });

      //console.log('lista colori', this.listaColori)
    },
  },
}
</script>

<style lang="scss" scoped>
h1, p, span, div {
  color: #fff;
}

.filter-btn {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  padding: 0;

  span {
    display: inline-block;
    padding-left: 5px;
    cursor: pointer;

    .opened {
      transform: rotate(90deg) !important;
    }
  }

  .filtro {
    width: 100%;
    .cat-title {
      margin-top: 20px;

      padding-left: 0;

    }

    .cat-icons {
      width: 100%;
      padding-left: 0;
     .cats {
       width: 100%;
       overflow-x: scroll;
       padding: 30px 0;
     }
      .cat-desc {
        display: inline-block;
        width: 20ch;
        white-space: nowrap;
       text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .color-title {
      margin-top: 20px;
      margin-bottom: 10px;

      padding-left: 0;

    }

    .col-icons {
      width: 100%;
      padding-left: 0;
      .cols {
        width: 100%;
        overflow-x: scroll;
        padding: 30px 0;
      }
    }

    .reset-filter {

      margin-top: 20px;
      font-size: 14px;


      padding-left: 0;

      span {
        color: var(--greenb2b);
        text-decoration: underline;
      }

    }

    ul.cols, ul.cats {
      display: flex;

      li {

        display: flex;
        cursor: pointer;
        flex-direction: column;
        align-items: center;
        text-transform: lowercase;
        margin-right: 7px;
        justify-content: center;
        position: relative;

        span {
          text-align: center;
        }

        .active-bar {
          bottom: -5px;

          position: absolute;
          width: 80%;
          height: 3px;
          background-color: var(--greenb2b);
        }

        &:first-letter {
          text-transform: uppercase;
        }

        li.colors {
          width: 50px;
        }

        .color-palette {
          margin-right: 7px;
          border-radius: 50%;
          width: 30px;
          height: 30px;

          &.bl {
            background-color: #000000;
          }

          &.ob {
            background-color: #1248BE;
          }

          &.ag {
            background-color: #34ee05;
          }

          &.sb {
            background-color: #2dbdd7;
          }

          &.rb {
            background-color: #E31C18;
          }

          &.nb {
            background-color: #E3CA87;
          }

          &.gb {
            background-color: #00B757;
          }

          &.bb {
            background-color: #783800;
          }

          &.bf {
            background-color: #0368F4;
          }

          &.cb {
            background-color: rgba(255, 255, 255, 0.68);
          }

          &.a {
            background-color: #D7D7D7;
          }

          &.pw {
            background-color: #FFFFFF;
          }

          &.of {
            background-color: #FF6340;
          }

          &.pg {
            background-color: #A4FFDD;
          }

          &.yb {
            background-color: #f5c207;
          }

          &.ib {
            background-color: #FCD498;
          }

          &.wb {
            background-color: #8cbbc4;
          }

          &.wg {
            background-color: #88c4ac;
          }

          &.bg {
            background-color: #123f2d;
          }

          &.dg {
            background-color: #505452;
          }

        }
      }
    }

    ul.cols {
      li {
        .active-bar {
          bottom: -8px;
          left: -1px;
        }
      }
    }

    ul.cats {
      margin-left: -5px;

      li {

      }
    }

    ul li img {
      width: 50px;
    }
  }
}
</style>
